import { createApi, createEvent, createStore } from "effector";
import { Dinero } from "dinero.js";
import { Supplement } from "../models";
import { resetAllSelectedStores } from "./resetAllSelected";

export const resetSelectedSupplements = createEvent(
  "reset selected supplements"
);
export type SelectedSupplement = {
  entity: Supplement;
  totalPrice: Dinero;
  totalTax: Dinero;
  quantity: number;
  serving: {
    packageId: number | null;
    activityId: number | null;
  };
};
export const $selectedSupplements = createStore<SelectedSupplement[]>([])
  .reset(resetSelectedSupplements)
  .reset(resetAllSelectedStores);
export const selectedSupplementsApi = createApi($selectedSupplements, {
  setQuantity: (store, v: { entity: Supplement; quantity: number }) => {
    const storeCloned = [...store];

    const item = storeCloned.find(({ entity: { id } }) => id === v.entity.id);
    if (item) {
      if (v.quantity !== 0) {
        item.quantity = v.quantity;
        item.totalPrice = v.entity.price.multiply(v.quantity);
      } else {
        storeCloned.splice(storeCloned.indexOf(item), 1);
      }
    } else {
      storeCloned.push({
        ...v,
        totalTax: v.entity.vat.multiply(v.quantity),
        totalPrice: v.entity.price.multiply(v.quantity),
        serving: { packageId: null, activityId: null },
      });
    }

    return storeCloned;
  },
  setServing: (
    store,
    v: { entity: Supplement; packageId?: number; activityId: number }
  ) => {
    const storeCloned = [...store];

    const item = storeCloned.find(({ entity: { id } }) => id === v.entity.id);
    if (item) {
      item.serving.activityId = v.activityId;
      item.serving.packageId = v.packageId ?? null;
    }

    return storeCloned;
  },
  remove: (store, v: { id: number }) => {
    const storeCloned = [...store];

    const idx = storeCloned.findIndex(({ entity: { id } }) => id === v.id);
    if (~idx) storeCloned.splice(idx, 1);

    return storeCloned;
  },
});
